/**
 * Hilfemethoden zum Parsen von URIs. Zum größten Teil schamlos kopiert von
 * https://github.com/manfredsteyer/angular-oauth-oidc/blob/master/app/components/oauth/oauth-service.js#L368
 *
 * Wir benötigen solche Hilfsmethoden trotz Angular Router, da z.B auf der Ebene der App-Component keine
 * Injection des RouteParams Service möglich ist.
 */
export class UriUtil {

    /**
     * Parst die Parameter aus dem URI Fragment der aktuellen location. Ist kein URI-Fragment vorhanden, wird die Query (?...) geparst.
     */
    public static getFragment(): { [key: string]: string } {
        if (location.hash.indexOf('#') === 0) {
            return UriUtil.parseQueryString(location.hash.substr(1));
        } else {
            return UriUtil.parseQueryString(location.toString().substr(location.toString().indexOf('?') + 1));
        }
    }

    public static parseQueryString(queryString: string): { [key: string]: string } {
        const data: { [key: string]: string } = {};
        let escapedKey: string;
        let escapedValue: string;

        if (queryString === null) {
            return data;
        }

        const pairs = queryString.split('&');

        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i];
            const separatorIndex = pair.indexOf('=');

            if (separatorIndex === -1) {
                escapedKey = pair;
                escapedValue = null;
            } else {
                escapedKey = pair.substr(0, separatorIndex);
                escapedValue = pair.substr(separatorIndex + 1);
            }

            let key = decodeURIComponent(escapedKey);
            const value = decodeURIComponent(escapedValue);

            if (key.substr(0, 1) === '/') {
                key = key.substr(1);
            }

            data[key] = value;
        }

        return data;
    }
}
